import { render, staticRenderFns } from "./CheckResultAdd.vue?vue&type=template&id=9638f940&scoped=true"
import script from "./CheckResultAdd.vue?vue&type=script&lang=js"
export * from "./CheckResultAdd.vue?vue&type=script&lang=js"
import style0 from "./CheckResultAdd.vue?vue&type=style&index=0&id=9638f940&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9638f940",
  null
  
)

export default component.exports